module.exports = __webpack_public_path__ + "img/ebooks-active.cc0aba0.svg";